import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const alertCssClasses = {
  Error: 'alert-danger',
  Warning: 'alert-warning',
  Confirmation: 'alert-success',
  Info: 'alert-info',
};
const defaultIcon = (<span className="alert__icon" aria-hidden="true" />);

let actionArray;

export class Alert extends React.Component {
  componentDidMount() {
    this.addActionListeners();
  }

  componentDidUpdate() {
    this.addActionListeners();
  }

  componentWillUnmount() {
    this.removeActionListeners();
  }

  actionButtonClickedHandler = (event) => {
    this.props.onActionClicked(event.target.innerText);
    if (_.isFunction(this.props.action.callback)) {
      this.props.action.callback();
    }
  }

  actionClickedHandler = (event) => {
    const innerText = event.target.nodeName === 'INPUT'
      ? event.target.value
      : event.target.innerText;

    this.props.onActionClicked(innerText);
  }

  addActionListeners() {
    // DOM operation only applies for the case when message is string
    if (_.isString(this.props.message)) {
      this.removeActionListeners();
      actionArray = Array.prototype.slice.call(this.alertMessageElement.querySelectorAll('a, button, input[type="button"]'));
      actionArray.forEach(anchor => anchor.addEventListener('click', this.actionClickedHandler));
    }
  }

  removeActionListeners() {
    if (_.isString(this.props.message) && actionArray) {
      actionArray.forEach(anchor => anchor.removeEventListener('click', this.actionClickedHandler));
    }
  }

  render() {
    const {
      level,
      hasIcon,
      customCssClass,
      icon,
      dismissible,
      message,
      action,
      onDismiss,
    } = this.props;

    const cssClass = customCssClass || alertCssClasses[level];
    const iconSpan = hasIcon && icon;
    const dismissButton = dismissible && (
      <button
        className={classnames('close', 'alert-ignore', 'clickable')}
        type="button"
        tabIndex="0"
        onClick={onDismiss}
      />
    );
    const actionButton = action && (
      <button
        className={classnames('btn', 'btn-default', 'alert__action')}
        type="button"
        onClick={this.actionButtonClickedHandler}
      >
        {action.message}
      </button>
    );
    /* eslint react/no-danger:0 */
    // TODO [Yucongj] Remove dangerouslySetInnerHTML
    const messageContent = _.isString(message)
      ? (
        <span
          className="alert__message"
          dangerouslySetInnerHTML={{ __html: message }}
          ref={(element) => {
            this.alertMessageElement = element;
          }}
        />
      ) : (
        <span className="alert__message">
          {message}
        </span>
      );

    return (
      <div className={classnames('alert', cssClass)} role="alert">
        {iconSpan}
        <div className="alert__content">
          {messageContent}
          {actionButton}
        </div>
        {dismissButton}
      </div>
    );
  }
}

Alert.propTypes = {
  level: PropTypes.oneOf(['Error', 'Warning', 'Confirmation', 'Info']),
  hasIcon: PropTypes.bool,
  customCssClass: PropTypes.string,
  icon: PropTypes.element,
  dismissible: PropTypes.bool,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  action: PropTypes.shape({
    message: PropTypes.string,
    callback: PropTypes.func,
  }),
  onDismiss: PropTypes.func,
  onActionClicked: PropTypes.func,
};

Alert.defaultProps = {
  level: 'Confirmation',
  hasIcon: true,
  customCssClass: '',
  icon: defaultIcon,
  dismissible: true,
  message: undefined,
  action: undefined,
  onDismiss: _.noop,
  onActionClicked: _.noop,
};
